import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { TUIComponents, TUIChatKit } from "./TUIKit";
import { TUITranslateService, TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import TUINotification from "./TUIKit/components/TUINotification/index";
import {
  Button,
  Form,
  FormItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Input,
  Checkbox,
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { locales } from "./locales";

const SDKAppID = 1721002346; // Your SDKAppID
// const SDKAppID = 20021761; // Your SDKAppID
const secretKey = "8f14fb28ca6edc890369917a3a77e810a7831782a6fca88f44123c2c560f5003"; // Your secretKey

TUIChatKit.components(TUIComponents, Vue);
TUIChatKit.init();

TUITranslateService.provideLanguages(locales);
TUITranslateService.useI18n();

Vue.config.productionTip = false;
Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Input);
Vue.use(Checkbox);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

/**
 * Init TUINotification configuration.
 */
TUINotification.setNotificationConfiguration({
  showPreviews: true,
  allowNotifications: true,
  notificationTitle: "Tencent Cloud Chat",
  notificationIcon: "https://web.sdk.qcloud.com/im/demo/latest/faviconnew.png",
});

/**
 * Listen for new messages and use notification components.
 * This capability is only available in the web environmen.
 */
TUIStore.watch(StoreName.CHAT, {
  newMessageList: (newMessageList: unknown) => {
    if (Array.isArray(newMessageList)) {
      newMessageList.forEach(message => TUINotification.notify(message));
    }
  }
});

export { SDKAppID, secretKey };
